import { cn } from '@/lib/utils';
import { MorphingDialog, MorphingDialogTrigger, MorphingDialogImage, MorphingDialogContainer, MorphingDialogContent, MorphingDialogClose } from './morphing-dialog';
import { IonIcon } from '@ionic/react';
import { closeOutline } from 'ionicons/icons';

interface GolfAvatarProps {
  imageUrl?: string;
  username?: string;
  name?: string;
  size?: number;
  canOpen?: boolean;
  className?: string;
}

export function GolfAvatar({
  imageUrl,
  name,
  username,
  size,
  className = '',
  canOpen = false
}: GolfAvatarProps) {
  const containerClass = `rounded-full ${className}`;

  if (canOpen) {
    return (
      <MorphingDialog
        transition={{
          duration: 0.3,
          ease: 'easeInOut',
        }}
      >
        <MorphingDialogTrigger>
          <MorphingDialogImage
            src={imageUrl ? imageUrl : '/assets/images/user.webp'}
            alt=''
            className={cn('rounded-full border-input/60 bg-secondary object-cover border', containerClass)}
            style={{ width: size ? `${size}px` : '', height: size ? `${size}px` : '' }}
          />
        </MorphingDialogTrigger>
        <MorphingDialogContainer>
          <MorphingDialogContent className='relative'>
            <MorphingDialogImage
              src={imageUrl ? imageUrl : '/assets/images/user.webp'}
              alt=''
              className='aspect-square max-w-[90vw] max-h-[90vh] w-[min(90vw,90vh)] h-[min(90vw,90vh)] rounded-full border-input/60 bg-secondary object-cover border'
            />
          </MorphingDialogContent>
          <MorphingDialogClose
            className='fixed right-6 top-6 h-fit w-fit rounded-full bg-white p-1'
            variants={{
              initial: { opacity: 0 },
              animate: {
                opacity: 1,
                transition: { delay: 0.3, duration: 0.1 },
              },
              exit: { opacity: 0, transition: { duration: 0 } },
            }}
          >
            <IonIcon icon={closeOutline} />
          </MorphingDialogClose>
        </MorphingDialogContainer>
      </MorphingDialog>
    );
  }
  else {
    return (
      <img
        src={imageUrl ? imageUrl : '/assets/images/user.webp'}
        alt=''
        className={cn('rounded-full border-input/60 bg-secondary object-cover border', containerClass)}
        style={{ width: size ? `${size}px` : '', height: size ? `${size}px` : '' }}
      />
    );
  }
}
